import { TableTemplate } from 'types/tableTemplate';

export const patientTableTemplate: TableTemplate[] = [
  {
    id: 'name',
    description: 'Paciente',
    originalId: 'name',
    width: 320,
  },
  {
    id: 'document_number',
    description: 'CPF/CNPJ',
    originalId: 'document_number',
    width: 170,
  },
  {
    id: 'phone',
    description: 'Telefone',
    originalId: 'phone',
    width: 160,
  },
  {
    id: 'formattedCityState',
    description: 'Cidade',
    originalId: 'formattedCityState',
    width: 200,
  },
  {
    id: 'formattedActive',
    description: 'Status',
    originalId: 'active',
    width: 110,
  },
];
